// extracted by mini-css-extract-plugin
module.exports = {"extraColors":"ExtraColors_extraColors__b3KuG"};